import React, { useRef } from 'react';
import { Box, DialogContent, Button, DialogActions } from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import OrderSheetPreview from './OrderSheetPreview';

const OrderSheetPreviewModal = ({
  type,
  open,
  handleClose,
  orderSheet,
  orderDetails,
  project,
}) => {
  const previewRef = useRef();

  const exportPDF = () => {
    const el = previewRef.current;
    html2canvas(el, { scale: '2' }).then((canvas) => {
      //document.body.appendChild(canvas);  // if you want see your screenshot in body.
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 210; // 이미지 가로 길이(mm) A4 기준
      const pageHeight = imgWidth * 1.414; // 출력 페이지 세로 길이 계산 A4 기준
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      const pdf = new jsPDF('p', 'mm', 'a4', true);
      let position = 0;

      // 첫 페이지 출력
      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
      heightLeft -= pageHeight;

      // 한 페이지 이상일 경우 루프 돌면서 출력
      while (heightLeft >= 20) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
      }

      pdf.save(orderSheet?.sheetCstNm + '발주서.pdf');
    });
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="draggable-preview-dialog"
      fullWidth={true}
      maxWidth="lg"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-preview-dialog"
        onClose={handleClose}
      >
        발주서 미리보기
      </BootstrapDialogTitle>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogContent
          dividers
          sx={{
            height: 600,
            overflowY: 'auto',
          }}
        >
          <OrderSheetPreview
            previewRef={previewRef}
            project={project}
            orderSheet={orderSheet}
            orderDetails={orderDetails}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="warning" onClick={exportPDF}>
            PDF 다운로드
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
};

export default OrderSheetPreviewModal;
